import { tv } from "../../../variants/tv.js";
const checkboxSizes = {
    16: {
        root: 'h-4 w-4',
        indicator: 'h-4 w-4',
        labelSlot: 'text-body3'
    },
    20: {
        root: 'h-5 w-5',
        indicator: 'h-5 w-5',
        labelSlot: 'text-body2'
    },
    24: {
        root: 'h-6 w-6',
        indicator: 'h-6 w-6',
        labelSlot: 'text-body1'
    }
};
const allowedCheckboxSizes = Object.keys(checkboxSizes);
const checkboxEmphasisVariants = {
    regular: {
        labelSlot: 'text-primary-13 has-data-disabled:text-primary-6',
        root: `
    text-primary-1 bg-primary-1 border border-primary-6
    hover:border-primary-10 focus-visible:outline-primary-8

    data-checked:bg-primary-8 data-checked:border-none
    hover:data-checked:bg-primary-9

    data-indeterminate:bg-primary-8 data-indeterminate:border-none
    hover:data-indeterminate:bg-primary-9

    data-disabled:bg-primary-2 data-disabled:text-primary-6 data-disabled:border-primary-5 data-disabled:hover:border-primary-5
    data-disabled:data-checked:bg-primary-2 data-disabled:data-checked:border-none
    data-disabled:hover:data-checked:bg-primary-2
    data-disabled:data-indeterminate:bg-primary-2 data-disabled:data-indeterminate:border-none
    data-disabled:hover:data-indeterminate:bg-primary-2 
    `
    },
    medium: {
        labelSlot: 'text-primary-13 has-data-disabled:text-primary-6',
        root: `
    text-primary-1 bg-primary-1/60 border border-primary-6
    hover:border-primary-10 focus-visible:outline-primary-8

    data-checked:bg-primary-8 data-checked:border-none
    hover:data-checked:bg-primary-9

    data-indeterminate:bg-primary-8 data-indeterminate:border-none
    hover:data-indeterminate:bg-primary-9

    data-disabled:bg-primary-1/60 data-disabled:text-primary-6 data-disabled:border-primary-5 data-disabled:hover:border-primary-5
    data-disabled:data-checked:bg-primary-1/60 data-disabled:data-checked:border-none
    data-disabled:hover:data-checked:bg-primary-1/60
    data-disabled:data-indeterminate:bg-primary-1/60 data-disabled:data-indeterminate:border-none
    data-disabled:hover:data-indeterminate:bg-primary-1/60
    `
    },
    bold: {
        labelSlot: 'text-primary-1 has-data-disabled:text-primary-1/40',
        root: `
    text-primary-8 bg-primary-1/20 border border-primary-1/40
    hover:border-primary-1 focus-visible:outline-primary-1

    data-checked:bg-primary-1 data-checked:border-none
    hover:data-checked:bg-primary-1/80

    data-indeterminate:bg-primary-1 data-indeterminate:border-none
    hover:data-indeterminate:bg-primary-1/80
    
    data-disabled:bg-primary-1/20 data-disabled:text-primary-1/40 data-disabled:border-primary-1/20 data-disabled:hover:border-primary-1/20
    data-disabled:data-checked:bg-primary-1/20 data-disabled:data-checked:border-none
    data-disabled:hover:data-checked:bg-primary-1/20
    data-disabled:data-indeterminate:bg-primary-1/20 data-disabled:data-indeterminate:border-none
    data-disabled:hover:data-indeterminate:bg-primary-1/20
    `
    }
};
const checkboxEmphases = Object.keys(checkboxEmphasisVariants);
const checkboxVariants = tv({
    slots: {
        labelSlot: 'has-data-disabled:cursor-not-allowed flex cursor-pointer flex-row gap-2',
        root: 'hover:shadow-input-hover data-checked:transition data-indeterminate:transition data-disabled:cursor-not-allowed data-disabled:hover:shadow-none group relative inline-flex flex-none cursor-pointer items-center justify-center rounded-sm align-middle transition focus-visible:outline-2 focus-visible:outline-offset-2',
        indicator: 'data-checked:transition data-indeterminate:transition inline-flex items-center justify-center overflow-hidden align-middle transition',
        icon: 'data-checked:transition data-indeterminate:transition transition'
    },
    variants: {
        size: checkboxSizes,
        emphasis: checkboxEmphasisVariants,
        isCheckboxGroup: {
            true: {}
        },
        layout: {
            vertical: {},
            horizontal: {}
        }
    },
    compoundVariants: [
        {
            isCheckboxGroup: true,
            layout: 'vertical',
            class: {
                labelSlot: 'w-full py-1'
            }
        }
    ],
    defaultVariants: {
        emphasis: 'regular',
        size: '20',
        layout: 'vertical'
    }
});
export { allowedCheckboxSizes, checkboxEmphases, checkboxEmphasisVariants, checkboxSizes, checkboxVariants };
